import { SectionContainer } from "../atoms/containers/ContentContainers";
import { SectionTrheeContent } from "../molecules/section_trhee_content/SectionTrheeContent";

export function SectionThree() {
	return (
		<SectionContainer id="process" variant="light">
			<SectionTrheeContent />
		</SectionContainer>
	);
}
